import { Typography } from '@mui/material';
import { type Props } from './types.ts';

export const ContentWithLineBreaks = ({ children, sx }: Props) => (
  <>
    {children.split('\n').map((p, i) => (
      <Typography key={i} sx={{ ...sx, marginBottom: theme => theme.spacing(1) }}>
        {p}
      </Typography>
    ))}
  </>
);
